import { either } from 'ramda';
import * as shopSelectors from './shops/selectors';
import * as reservationSelectors from './reservation/selectors';

// eslint-disable-next-line import/prefer-default-export
export const getShopId = either(shopSelectors.getShopId, reservationSelectors.getShopId);

export const getThirdPartyPromotion = state => state.app.get('thirdPartyPromotion');



// WEBPACK FOOTER //
// ./src/app/selectors.js